const binding = { modules: {}, dataActions: {} };

    (binding.modules['mil-search'] = {
        c: () => require('partner/modules/mil-search/mil-search.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mil-search',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mil-search'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mil-search|mil-search'] = {
                c: () => require('partner/modules/mil-search/mil-search.view.tsx'),
                cn: '__local__-__local__-mil-search'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };